import { useEffect, useState } from 'react';
import styled from 'styled-components';

import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Avatar from '@mui/material/Avatar';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import CloseRounded from '@mui/icons-material/CloseRounded';


const TagContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	flex-direction: row;
`;

const ProductItem = styled.div`
	position: relative;
	display: flex;
	margin: 5px 5px 0px 0px;
	border-radius: 50px;
	background: rgba(0, 0, 0, 0.08);
	align-items: center;
`;

const ImageContainer = styled.div``;

const ProductContent = styled.div`
	display: flex;
	flex-direction: column;
`;

const TitleContainer = styled.div`
	padding: 4px 8px;
	display: flex;
	flex-direction: row;
	align-items: center;
	font-size: 14px;
`;

const RemoveIconWrapper = styled.div`
	border-radius: 50px;
	padding: 3px;
	display: flex;
	align-items: center;
	cursor: pointer;
	margin: 0 10px 0 4px;
	background: rgba(0, 0, 0, 0.2);
	color: white;
`;

const InputImgContainer = styled.div`
	position: relative;
	margin-left: 5px;
	margin-right: 3px;
	left: 0;
	right: 0;
	text-align: center;
`;

const SkuList = (props) => {
	const {
		options,
		onSelectedOptionsChange,
		value,
		isMultiple = false,
		filterSelectedOptions = false
	} = props;

	const [selectedValue, setSelectedValue] = useState(isMultiple ? [] : null);

	useEffect(() => {
		if (value && value.length > 0) {
			setSelectedValue(!isMultiple ? value[0] : value);
		}
		if (!value) {
			setSelectedValue(isMultiple ? [] : null)
		}
	}, [props, isMultiple, value]);

	const changeHandler = (event, newValue) => {
		onSelectedOptionsChange(newValue);
		setSelectedValue(newValue);
	};

	return (
		<Autocomplete
			multiple={isMultiple}
			id="autocomplete-sku-select"
			key="tag-sku-autocomplete"
			options={options}
			getOptionLabel={(option) => option.title}
			value={selectedValue}
			onChange={changeHandler}
			filterSelectedOptions={filterSelectedOptions}

			renderOption={(props, option) => (
				<ListItem {...props} key={option.id}>
					<ListItemAvatar>
						<Avatar alt={option.title} src={option.imageUrl} />
					</ListItemAvatar>
					<ListItemText primary={option.title} />
				</ListItem>
			)}

			renderTags={(value, getTagProps) => {
				return (
					<TagContainer>
						{value.map((option, index) => (
							<ProductItem key={option.id}>
								<ImageContainer>
									<Avatar alt={option.title} src={option.imageUrl} />
								</ImageContainer>
								<ProductContent>
									<TitleContainer>
										<span>{option.title}</span>
									</TitleContainer>
								</ProductContent>
								<RemoveIconWrapper onClick={getTagProps({ index }).onDelete}>
									<CloseRounded fontSize="12px" />
								</RemoveIconWrapper>
							</ProductItem>
						))}
					</TagContainer>
				)
			}}

			renderInput={(params) => {
				const selectedOption = params.inputProps.value
					? options.find(option => option.title === params.inputProps.value)
					: null;

				const inputProps = !isMultiple && !!selectedOption ? {
					startAdornment: (
						<InputImgContainer position="start">
							<Avatar
								alt={selectedOption.title}
								src={selectedOption.imageUrl}
								sx={{ width: 24, height: 24 }}
							/>
						</InputImgContainer>
					)
				} : {};

				return (
					<TextField
						{...params}
						variant="filled"
						label="SKU"
						InputProps={{
							...params.InputProps,
							...inputProps,
							sx:{ paddingBottom: '8px' }
						}}
					/>
				);
			}}

		/>
	);
};

export default SkuList;